<template>
    <el-dialog :visible.sync="visible" title="新增工程量清单" :close-on-click-modal="false" :close-on-press-escape="false">
        <el-form :inline="true" :model="dataForm" label-width="100px">
            <el-row>
                <el-col :span="6">
                    <el-form-item label="细目名称：">
                        <el-input v-model="dataForm.subCategoryName" placeholder="请输入细目名称" clearable></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="细目号：">
                        <el-input v-model="dataForm.subCategoryNo" placeholder="请输入细目号" clearable></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12" class="btnRight">
                    <el-form-item class="btnList">
                        <el-button type="primary" @click="query()">查 询</el-button>
                        <el-button type="info" @click="reset()">重 置</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <div class="selectTitleTxt">已选择</div>
        <div class="listBox">
            <div class="noSelectList">
                <el-table
                        ref="dataTable"
                        :data="noSelectList"
                        @row-click="rowNoClicked"
                        highlight-current-row
                        size="mini"
                        height="100%"
                        border
                >
                    <el-table-column prop="subCategoryName" label="细目名称" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="subCategoryNo" label="细目号" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="unit" label="单位" :show-overflow-tooltip="true"></el-table-column>
                </el-table>
            </div>
            <div class="btnList">
                <i class="el-icon-arrow-left" @click="deleteBtn"></i>
                <i class="el-icon-arrow-right" @click="addBtn"></i>
            </div>
            <div class="selectList">
                <el-table
                        ref="dataTable1"
                        :data="selectList"
                        highlight-current-row
                        @row-click="rowClicked"
                        size="mini"
                        height="100%"
                        border
                >
                    <el-table-column :prop="dataForm.subContractTypeEnum === 'MATERIAL'?'productName':'subCategoryName'" label="细目名称" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column :prop="dataForm.subContractTypeEnum === 'MATERIAL'?'productNumber':'subCategoryNo'" label="细目号" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="unit" label="单位" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="unitPrice" label="单价" :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            <el-input size="mini" v-model="scope.row.unitPrice" :readonly="scope.row.isDisabled"></el-input>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <el-footer class="container">
            <div class="btnMid">
                <el-button type="info" @click="visible = false">取 消</el-button>
                <el-button type="primary" @click="submitBtn()">保 存</el-button>
            </div>
        </el-footer>
    </el-dialog>
</template>

<script>
    import {
        queryProjectDetailsService,
    } from "../../../services/engineering";
    import {addOtherDataService,queryOtherListService}from "../../../services/feeServices";

    export default {
        name: "add-bill",
        data(){
            return {
                visible: false,
                dataForm: {
                    subCategoryName: '',        //细目名称
                    subCategoryNo: '',          //细目号
                },
                noSelectList: [],
                selectList: [],
                newSelectList: [],
                rowNoClickedList: null,
                rowClickedList: null,
                projectId:'',
            }
        },
        methods: {
            init(){
                this.visible = true;
                this.$nextTick(()=> {
                    this.noSelectList = [];
                    this.selectList = [];
                    this.newSelectList = [];
                    this.subContractTypeEnum= '';
                    this.dataForm = {
                        subCategoryName: '',        //细目名称
                        subCategoryNo: '',          //细目号
                    }
                    this.queryOtherDirectData();
                })
            },
            /**
             * 查询其它直接费工程量清单细目
             * */
            queryOtherDirectData(){
                let paramsData = {
                    feeType: "DIRECT",
                    projectId: this.projectId,
                    pageIndex: 1,
                    pageSize: 10000,
                }
                queryOtherListService(paramsData).then( res => {
                    if(res.code == 10000000){
                        res.data.map(item => {
                            item.isDisabled = true;
                        })
                        this.selectList = res.data;
                        this.queryProjectDetails();
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            queryProjectDetails() {
                let paramsData = {
                    ...this.dataForm,
                    pageIndex: 1,
                    pageSize: 10000,
                    dictIdSet: this.selectList.map(item => {
                        return item.id
                    })
                }
                queryProjectDetailsService(paramsData).then( res => {
                    if(res.code == 10000000){
                        this.noSelectList = res.data;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            /**
             * 查询列表
             */
            query(){
                this.queryProjectDetails();
            },
            //重置
            reset(){
                this.dataForm.subCategoryName = ''
                this.dataForm.subCategoryNo = ''
                this.query();
            },
            //删除数据
            deleteBtn(){
                if(this.newSelectList.findIndex(item => item.id == this.rowClickedList.id) == -1){
                    this.$message.error('已添加的数据不能移除！');
                    return
                }
                if (this.rowClickedList) {
                    let index=this.selectList.findIndex(item=>item.id=this.rowClickedList.id)
                    this.selectList.splice(index,1)                 
                    index=this.newSelectList.findIndex(item=>item.id=this.rowClickedList.id)
                    this.newSelectList.splice(index,1)
                    console.log(this.newSelectList)
                    this.rowClickedList = null;
                }
            },
            //添加数据
            addBtn(){
                if (this.rowNoClickedList) {
                    this.selectList.push({
                        ...this.rowNoClickedList,
                        unitPrice: null,
                    })
                    this.newSelectList.push({
                        ...this.rowNoClickedList,
                        unitPrice: null,
                    })
                    this.noSelectList.splice(this.noSelectList.indexOf(this.rowNoClickedList),1)
                    this.rowNoClickedList = null;
                }
            },
            // 点击选中行
            rowNoClicked(row, event, column) {
                this.$refs.dataTable.toggleRowSelection(row);
                this.rowNoClickedList = row;
            },
            rowClicked(row, event, column) {n 
                this.$refs.dataTable1.toggleRowSelection(row);
                this.rowClickedList = row;
            },
            submitBtn(){
                if(this.selectList.length<1)
                {
                     this.$message.error('请选择总包细目');
                    return;
                }
                if (this.selectList.findIndex(item =>  item.unitPrice != 0 && item.unitPrice == null) != -1){
                    this.$message.error('请填写单价后再提交！');
                    return;
                }
                let voList = [];
                this.selectList.map(item => {
                    if(this.newSelectList.findIndex(newItem => newItem.id == item.id) != -1){
                        voList.push({
                            ...item,
                            projectId: this.projectId,
                        })
                    }
                })
                let paramsData = {
                    voList: voList
                }
                addOtherDataService(paramsData).then( res => {
                    if(res.code == 10000000){
                        this.visible = false;
                        this.$message.success("新增成功！");
                        this.$emit('refreshDataList')
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            }
        }

    }
</script>

<style scoped lang="scss">
    /deep/.el-dialog{
        width: 70%;
    }
    .titleBox{
        display: flex;
        color: #101010;
        font-size: 16px;
        text-align: left;
        font-family: SourceHanSansSC-regular;
        font-weight: 600;
        border-bottom: 1px solid #bbbbbb;
        margin: 20px;
        padding-bottom: 10px;
    }
    .btnRight {
        display: flex;
        justify-content: flex-end;
    }
    .selectTitleTxt{
        margin-left: 55%;
        color: rgba(61, 61, 62, 100);
        font-size: 14px;
        margin-bottom: 12px;
    }
    .listBox{
        padding: 0 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .noSelectList{
            width: 45%;
            height: 200px;
            border: 1px solid rgba(187, 187, 187, 100);
        }
        .btnList {
            width: 5%;
            height: 100px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-around;
            i {
                font-size: 24px;
                font-weight: 600;
            }
        }
        .selectList{
            width: 45%;
            height: 200px;
            border: 1px solid rgba(187, 187, 187, 100);
        }
    }
    .container{
        width: 100%;
        margin-top: 60px;
        display: flex;
        justify-content: center;
    }
</style>
